import { render, staticRenderFns } from "./ItemPlannerItem.vue?vue&type=template&id=4029ae24&scoped=true&"
import script from "./ItemPlannerItem.vue?vue&type=script&lang=js&"
export * from "./ItemPlannerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029ae24",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BButton, BCol, BRow})
    

export default component.exports